import {ReactText, useContext} from 'react';
import TextButton from '../../common/component/TextButton';
import {CommentThemeContext} from '../common';
import {ICommentButonEffect} from '../type';

interface IProps {
  isSelect?: boolean;
  selectedEffect?: ICommentButonEffect;
  isBtnForReply?: boolean;
  onClick?: () => void;
  children: ReactText;
  className?: string;
}

export default function CommentButton({
  isSelect = false,
  selectedEffect = 'color',
  isBtnForReply,
  onClick,
  children,
  className,
}: IProps) {
  const {
    buttonTheme: {effectStyle, ...defaultStyle},
  } = useContext(CommentThemeContext);
  const {textStyle, bgStyle, bgStyleForReply} = isSelect
    ? effectStyle[selectedEffect]
    : defaultStyle;

  return (
    <TextButton
      textClassName={cn(
        'items-center inline-flex h-full align-middle',
        textStyle
      )}
      className={cn(
        'h-28 rounded-8 px-12',
        isBtnForReply && bgStyleForReply ? bgStyleForReply : bgStyle,
        className
      )}
      onClick={onClick}
    >
      {children}
    </TextButton>
  );
}
